function cov_1tn75exj6m() {
  var path = "/app/src/utils/get-subvention-faq-link.ts";
  var hash = "b7e8ca31f607a7a24063cacf95610ec0f6c4ba28";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-subvention-faq-link.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 36
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 4,
          column: 19
        },
        end: {
          line: 4,
          column: 52
        }
      },
      "2": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 64
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 36
          },
          end: {
            line: 3,
            column: 37
          }
        },
        loc: {
          start: {
            line: 3,
            column: 72
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 3
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 19
          },
          end: {
            line: 4,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 4,
            column: 35
          },
          end: {
            line: 4,
            column: 42
          }
        }, {
          start: {
            line: 4,
            column: 45
          },
          end: {
            line: 4,
            column: 52
          }
        }],
        line: 4
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b7e8ca31f607a7a24063cacf95610ec0f6c4ba28"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1tn75exj6m = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1tn75exj6m();
cov_1tn75exj6m().s[0]++;
export var getSubventionFaqLink = function getSubventionFaqLink(lang, campaignId) {
  cov_1tn75exj6m().f[0]++;
  var langCode = (cov_1tn75exj6m().s[1]++, lang === 'ar' ? (cov_1tn75exj6m().b[0][0]++, 'ar-AE') : (cov_1tn75exj6m().b[0][1]++, 'en-AE'));
  cov_1tn75exj6m().s[2]++;
  return "https://tabby.ai/".concat(langCode, "/campaigns/").concat(campaignId);
};